import React from 'react';
import { BONOS } from '../../data/content';
import { VALOR_BONOS } from '../../utils/constants';
export function Bonuses() {
  return <section className="bg-violeta-profundo text-crema py-16 sm:py-20 px-5" data-id="element-45" data-mp="1hiptna4tfrqf">
      <div className="max-w-6xl mx-auto" data-id="element-46" data-mp="1cm7owa9hjte3">
        <div className="text-center max-w-3xl mx-auto" data-id="element-47" data-mp="1cj3bcma4rlar">
          <h2 className="font-serif text-3xl sm:text-4xl font-bold leading-tight" data-id="element-48" data-mp="18km504yjaeue">
            Además, 6 bonos gratis
          </h2>
          <p className="mt-4 text-lg text-crema/75" data-id="element-49" data-mp="257r5768y3izx">
            Los casos que aparecen en la mitad de las casas y que ningún cuadernillo resuelve.
          </p>
        </div>

        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-50" data-mp="1w7u8qigbdfub">
          {BONOS.map((bono, i) => <article key={bono.titulo} className="rounded-2xl bg-white/5 border border-white/10 p-5 flex flex-col" data-id="element-51" data-mp="1r9sse5a9vumj" data-mpi={i}>
              <div className="relative" data-id="element-52" data-mp="fudtux2f0upb">
                <img src={bono.img} alt={`Bono ${i + 1}: ${bono.titulo}`} loading="lazy" className="w-full h-44 object-contain" data-id="element-53" data-mp="ftlz1ogn7103" />
                <span className="absolute top-0 right-0 bg-coral text-white text-[11px] font-bold uppercase tracking-widest px-3 py-1 rounded-full" data-id="element-54" data-mp="1jqdravhnw787">
                  Gratis
                </span>
              </div>
              <h3 className="mt-4 font-serif text-xl font-bold" data-id="element-55" data-mp="w35iw4oxsi1y">{bono.titulo}</h3>
              <p className="mt-2 text-sm sm:text-base text-crema/75 leading-snug flex-1" data-id="element-56" data-mp="w1cd0rm5e1v0">
                {bono.descripcion}
              </p>
              <p className="mt-4 flex items-baseline gap-2" data-id="element-57" data-mp="n3a6jwjnah0c">
                <span className="text-crema/50 line-through" data-id="element-58" data-mp="n0o1q4o52flt">{bono.valor}</span>
                <span className="text-coral font-bold" data-id="element-59" data-mp="r4cagqoibh8n">GRATIS</span>
              </p>
            </article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-dorado/50 bg-white/5 px-6 py-6 text-center" data-id="element-60" data-mp="i34mb1fpfwsa">
          <p className="font-serif text-xl sm:text-2xl font-semibold" data-id="element-61" data-mp="2jsbkgutcak9b">
            Los 6 bonos solos valen {VALOR_BONOS}
          </p>
          <p className="mt-1 text-crema/70" data-id="element-62" data-mp="2f11uft3vpeww">Hoy entran incluidos en el kit, sin costo extra.</p>
        </div>
      </div>
    </section>;
}